@if (title) {
	<span class="plc-label__title" [innerHTML]="title"> </span>
}
<span
	#textContainer
	class="plc-label__text"
	[class]="hiddenClass"
	(cdkObserveContent)="triggerDetection()"
>
	<ng-content></ng-content>
</span>
